import { Component, h, Prop, Watch } from '@stencil/core';
import { CmsLink } from '../../../types/global';

interface UiCmsContactChannelsFooterMiscellaneousBody {
  iconPath: string;
  text: string;
  link: CmsLink;
}

@Component({
  tag: 'ui-cms-contact-channels-footer-miscellaneous',
  styleUrl: 'ui-cms-contact-channels-footer-miscellaneous.scss',
})
export class UiCmsContactChannelsFooterMiscellaneous {
  @Prop({ mutable: true }) body: UiCmsContactChannelsFooterMiscellaneousBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  render() {
    return (
      <div class="contactbox__item">
        <sd-icon
          library={window.ui.cmsState.iconLibrary}
          class="contactbox__icon"
          name={this.body.iconPath}
          color="primary"
        ></sd-icon>
        <div>
          <p class={{ copy: true, 'sd-paragraph': true, 'sd-paragraph--inverted': this.inverted }}>
            <span innerHTML={this.body.text}></span>
          </p>
          {this.body.link && (
            <sd-link inverted={this.inverted} target={this.body.link.target} href={this.body.link.src} size="inherit">
              <span aria-hidden={this.body.link.ariaLabel ? 'true' : 'false'} innerHTML={this.body.link.title}></span>
              <span class="sr-only">{this.body.link.ariaLabel}</span>
            </sd-link>
          )}
        </div>
      </div>
    );
  }
}
